import type { ReactNode } from 'react';
import { createContext } from 'react';

export type SupportRecipient = 'support' | 'coding';

export interface SupportContextValue {
  /** User-facing label, e.g. "Intake for John Doe". Supports JSX for rich formatting. */
  label?: ReactNode;
  /** Email subject line, e.g. "Intake request - John Doe" */
  subject?: string;
  /** Hidden context included in email body but not shown to user */
  hiddenContext?: Record<string, string>;
  /** Which team receives the email. Defaults to 'support'. */
  recipient?: SupportRecipient;
}

export const SUPPORT_RECIPIENT_EMAILS: Record<SupportRecipient, string> = {
  support: 'support@rogerhealthcare.com',
  coding: 'coding@rogerhealthcare.com',
};

export interface SupportContextState {
  context: SupportContextValue;
  setContext: (ctx: SupportContextValue) => void;
  clearContext: () => void;
}

export const SupportContext = createContext<SupportContextState | null>(null);
